/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Presentation(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M216,40H136V24a8,8,0,0,0-16,0V40H40A16.01833,16.01833,0,0,0,24,56V176a16.01833,16.01833,0,0,0,16,16H79.35547L57.75293,219.00293a7.99979,7.99979,0,1,0,12.49414,9.99414L99.84473,192h56.31054l29.59766,36.99707a7.99979,7.99979,0,0,0,12.49414-9.99414L176.64453,192H216a16.01833,16.01833,0,0,0,16-16V56A16.01833,16.01833,0,0,0,216,40Z" />
    </Svg>
  );
}

export default Presentation;
